import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    Accepted: "appication/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("au"));
    if (user) {
      config.headers.authorization = user.atkn;
      config.headers.orgid = user.claims.userOrg.orgId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
